<div class="p-md-4">
  <h2 class="m-4">Résultats de la recherche "{{ searchTerm }}"</h2>
  <app-company-list 
    [searchMode]="true" 
    [searchResults]="searchResults"
    [searchTerm]="searchTerm">
  </app-company-list>
</div>